module.exports = __webpack_public_path__ + "static/media/chef-white.b62bf01c.svg";